module.exports = __webpack_public_path__ + "media/images/microbius-logo-mini-ng-428106f9889371955851eb650c3f071b.png";